import React from "react";
import { useEffect, useRef } from "react";

export default function AdsenseAd() {
  const adRef = useRef<HTMLModElement>(null);

  useEffect(() => {
    try {
      if (typeof window !== "undefined") {
        (window as any).adsbygoogle = (window as any).adsbygoogle || [];
        (window as any).adsbygoogle.push({});
      }
    } catch (e) {
      console.error(e);
    }
  }, []);

  return (
    <ins className="adsbygoogle"
      style={{ display: "block" }}
      data-ad-client="ca-pub-6523735154193345"
      data-ad-slot="6027317728"
      data-ad-format="auto"
      data-full-width-responsive="true"
      ref={adRef}></ins>
  );
}
